module.exports = __webpack_public_path__ + "static/media/chief-Entrepreneurial.1e9012e9.png";